<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />

    <tl-header type="h1">
      <div class="main-header">Settle FBP Claims</div>
    </tl-header>

    <toast-message :message="errmsg" type="error" :isToastEnable='toast' @close="(val) => toast = val" />




        <div v-show="!isActionClicked" class="margin-top-20">
            <tl-select label="Select Month" labelText="name" :options="monthsData" v-model="formData.month" @change="changeMonth($event)"
              name="month"></tl-select>
          </div>

    <div  v-show="!isActionClicked">
      

      <div class="margin-top-20">
        <data-table :columns="headerColumnList" :tableData="dataList" :showinrow="showinrow" :showedit="showedit">
          <template v-slot:rowcontent="slotprops">
            <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"
            />
            <p v-if="slotprops.value.column.key!='imgSrc'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <btn v-if="slotprops.value.column.key=='actions'" :text="slotprops.value.record.isAlreadySettled ? 'Resettle':'Settle'" type="secondary"
              v-bind:class="{'resettle-btn':slotprops.value.record.isAlreadySettled}" v-on:click="goToSettlePage(slotprops.value)"
            />
          </template>
        </data-table>
      </div>

    </div>
    <empl-page v-if="isActionClicked" :employeeDetails="employeeDetails" @cancel="(val) =>isActionClicked = val "></empl-page>
  </div>
</template>

<script>
  import EmplPage from "./SettleFbpClaimsEmplPage.vue";
  import { mapActions, mapGetters, mapState } from "vuex";
  export default {
    components: {
      EmplPage
    },
    data() {
      return {
        monthsData: [
          { name: "January", val: "jan" },
          { name: "February", val: "feb" },
          { name: "March", val: "mar" },
          { name: "April", val: "apr" },
          { name: "May", val: "may" },
          { name: "June", val: "jun" },
          { name: "July", val: "jul" },
          { name: "August", val: "aug" },
          { name: "September", val: "sep" },
          { name: "October", val: "oct" },
          { name: "November", val: "nov" },
          { name: "December", val: "dec" }
        ],
        toast: false,
        errmsg: "",
        selectedMonth: "",
        formData: {},
        showinrow: false,
        showedit: false,
        isActionClicked: false,
        employeeDetails: {},
        breadcrumbList: [
          {
            name: "Payroll",
            url: `/dashboard/${this.$route.params.entity_index}/payroll`
          },
          {
            name: "Utilities",
            url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/`
          },
          {
            name: "Settle FBP Claims",
            url: ""
          }
        ],
        dataList: [
          // {
          //   code: "RC1234",
          //   imgSrc: require("@/assets/user.svg"),
          //   employeeName: "Roxie Schmidt",
          //   claimAmount: "₹2000.00",
          //   approvedAmount: "₹0.00",
          //   fbpMonth: "July",
          //   totalEligibility: "₹1800.00",
          //   isAlreadySettled: false
          // },
          // {
          //   code: "RC1454",
          //   imgSrc: require("@/assets/user.svg"),
          //   employeeName: "Trevor Riley",
          //   fbpMonth: "September",
          //   claimAmount: "₹4000.00",
          //   approvedAmount: "₹500.00",
          //   totalEligibility: "₹2000.00",
          //   isAlreadySettled: true
          // }
        ],
        headerColumnList: [
          { label: "", key: "imgSrc" },
          { label: "Code", key: "code" },
          { label: "Employee Name", key: "name" },
          { label: "Claim Amount", key: "claimedAmount" },
          { label: "Approved Amount", key: "amount_approved" },
          { label: "Actions", key: "actions" }
        ]
      };
    },
    mounted() {
      //this.getFBPClaimsByMonth();
    },
    computed: {
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),
      ...mapState({
        employeesExitsData: state => state.dashboard.add_exit_employees.exits,
        employeesJoiningsData: state => state.payroll.joinings.joinings //fetch all employees data
      }),
      le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
      }
    },
    methods: {
      ...mapActions({
        fetchFBPClaimsByMonth:
          "dashboard/payroll/utilities/settlefbpclaims/fetchAll"
      }),
      goToSettlePage(data) {
        this.isActionClicked = true;
        this.employeeDetails.month = this.selectedMonth;
        this.employeeDetails = data.record;
        //console.log(this.employeeDetails);
      },

      changeMonth(val) {
        //console.log("changeMonth:", val);
        this.selectedMonth = val.name;
        this.getFBPClaimsByMonth(val.val);
      },

      async getFBPClaimsByMonth(month) {
        //console.log("month", month);
        try {
          let data = month;
          let res = await this.fetchFBPClaimsByMonth(month);

          if (res.status == 200) {
            this.dataList = res.data.payload.data;
          }
          this.toast = false;
          //console.log(res);
        } catch (error) {
          //console.log(error);
          this.errmsg = error;
          this.toast = true;
        }
      },
      routeToMainStep() { },
      routeToSubStep() { }
    }
  };
</script>
<style lang="scss" scoped>
  @import "@/scss/dashboard/_variables.scss"; // Common
  @import "@/scss/dashboard/content/_section.scss"; // Content Section
  .component-wrapper {
    margin-left: 14px;
    margin-top: 10px;
  }

  .main-header {
    color: #6d6d6d;
    margin-top: 37px;
    font-size: 16px;
  }

  .margin-top-20 {
    margin-top: 20px;
  }

  .nav {
    color: #555555;
    font-size: 11px;
  }

  .filters {
    display: grid;
    grid-gap: 10px;
    grid-template: auto / repeat(4, minmax(200px, 1fr));
  }

  .sm-img {
    width: 35%;
  }

  .resettle-btn {
    border: #5d409f solid 1px;
    color: #5d409f;
  }
</style>